var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-card',{staticClass:"py-2 mx-0 px-0"},[_c('v-card-title',{staticClass:"pa-2"},[_vm._v(" "+_vm._s(_vm.previewSubject)+" ")]),_c('div',{staticClass:"pa-2 preview",domProps:{"innerHTML":_vm._s(_vm.previewBody)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }